import type { FieldMeta } from 'vee-validate';

export const FieldSize = {
  MD: 'md',
  SM: 'sm',
} as const;

export type FieldSizeType = (typeof FieldSize)[keyof typeof FieldSize];

export type FormFieldProps = {
  id?: string;
  label?: string;
  optionalLabel?: boolean;
  helperText?: string;
  error?: string;
  warning?: string;
  announceWarning?: boolean;
  meta?: FieldMeta<unknown>;
  size?: FieldSizeType;
  disabledReason?: string;
};
